// @flow
import omit from 'lodash/omit';
import { currentSubscriptionSelector } from '../Dashboard';
import { subscriptionBySerialNumberSelector } from '../Subscriptions';
import type { AgreementSpecification } from 'digicel-kaizen-library';

export const agreementSpecificationsSelector = (state: any): AgreementSpecification[] => {
  const agreements = state.agreements;

  if (!agreements) {
    return [];
  }

  return agreements.agreementSpecifications;
};

export const hasAlreadyValidatedNeededAgreementsSelector = (state: any): boolean => {
  const currentSubscription = currentSubscriptionSelector(state);

  if (!currentSubscription) {
    return false;
  }

  const checkedCheckboxes: string[] = currentSubscription.agreementSpecificationOuids;
  const requiredCheckboxes: AgreementSpecification[] = agreementSpecificationsSelector(state);
  if (!requiredCheckboxes.length) {
    return true;
  }

  return !requiredCheckboxes.filter(requiredCheckbox => {
    for (const checkedBoxOuid of checkedCheckboxes) {
      if (checkedBoxOuid === requiredCheckbox.ouid) {
        return false;
      }
    }

    return true;
  }).length;
};

export const selectedAgreementSpecificationsSelector = (state: any): AgreementSpecification[] => {
  const agreementSpecifications = agreementSpecificationsSelector(state);

  if (!agreementSpecifications) {
    return [];
  }

  return agreementSpecifications
    .filter(agreementSpecification => agreementSpecification.isSelected)
    .map(agreementSpecification => omit(agreementSpecification, 'isSelected')); // isSelected not needed by SDK
};

export const agreementsStateSelector = (state: any): boolean => {
  const agreementSpecifications = agreementSpecificationsSelector(state);
  let agreementsState = false;

  if (!agreementSpecifications) {
    return agreementsState;
  }

  agreementsState = !agreementSpecifications.some(
    agreementSpecification => agreementSpecification.isSelected === false
  );
  return agreementsState;
};

export const agreementsBySubscriptionProductSerialNumberSelector = (
  state: any,
  serialNumber: string
): AgreementSpecification[] => {
  const subscription = subscriptionBySerialNumberSelector(state, serialNumber);
  const agreementSpecifications = agreementSpecificationsSelector(state);

  if (!subscription || !agreementSpecifications) {
    return [];
  }

  const agreementsBySerialNumber = agreementSpecifications.filter(agreementSpecification =>
    subscription.agreementSpecificationOuids.find(ouid => ouid === agreementSpecification.ouid)
  );

  return agreementsBySerialNumber;
};
